/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import { Component, Prop, Watch } from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {mixins} from 'vue-class-component';
import GuideComponent from '@/mixins/DynamicComponent/Guide';

const namespaceSettings: string = 'settingsModule';

/**
 * Help component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-userguide',
})

export default class UserGuide extends mixins(GuideComponent) {
    @Getter('hasMedia', {namespace: namespaceSettings}) public hasMedia!: (name: string) => boolean;
    @Prop(String) public categoryId!: string;
    public category: string = 'overview';

    public readonly categories: string[] = ['overview', 'user-guide', '3d-software', 'scene-setup', 'modelling',
        'animation', 'texturing-and-uvs', 'materials', 'physics', 'exporting', 'example-scenes', 'error-descriptions'];

    /**
     * Paramater watcher to check for route changes and load category.
     *
     * @param category
     */
    @Watch('$route.params.categoryId')
    public routeChanged(category: string): void {
        if (undefined === category) {
            category = this.categories[0];
        }

        if (category !== this.category) {
            this.switchCategory(category);
        }
    }

    /**
     * Check for selected status of category.
     *
     * @param {string} category
     *
     * @returns {boolean}
     */
    public selected(category: string): boolean {
        return category === this.category;
    }

    /**
     * Created lifecycle event.
     */
    public created(): void {
        if (!this.categoryId) {
            return;
        }

        this.changeCategory(this.categoryId);
    }

    /**
     * Change the category.
     *
     * @param {string} category
     */
    public switchCategory(category: string): boolean {
        if (this.categories.indexOf(category) <= -1) {
            return false;
        }

        this.category = category;

        return true;
    }

    /**
     * Change the category.
     *
     * @param {string} category
     */
    public changeCategory(category: string): void {
        if (!this.switchCategory(category)) {
            return;
        }
        this.$router.push({name: 'userguide', params: {categoryId: this.category}});
    }
}
